// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-collapse{border-bottom:none!important}.space_group_title{position:relative;width:100px;display:inline-block;text-indent:1em}", ""]);
// Exports
module.exports = exports;
